import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AutoKeyBusinessService } from '../../business-services/auto-key.service';


@Injectable({ providedIn: 'root' })
export class ViewAutoKeyGuard  {

  constructor(
    private service: AutoKeyBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.service.appointmentId) {
      return true;
    }
    return this.router.createUrlTree(['/autoKey']);
  }
}
